module.exports = __webpack_public_path__ + "img/currentyear-budget.ae334d73.svg";